module.exports = __webpack_public_path__ + "img/96.646c92c0.jpg";